var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.user,
      expression: "loading.user"
    }],
    attrs: {
      "title": "user"
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("   "), _vm.payload.is_deleted ? _c('span', {
    staticStyle: {
      "color": "#f56c6c",
      "font-style": "italic",
      "font-weight": "500"
    }
  }, [_vm._v(" deleted ")]) : _vm.payload.is_in_paying_team ? _c('span', {
    staticStyle: {
      "color": "#67c23a",
      "font-style": "italic",
      "font-weight": "500"
    }
  }, [_vm._v(" in paying team ")]) : _vm._e(), _c('span', {
    staticStyle: {
      "color": "#909399",
      "font-style": "italic",
      "opacity": "0.5"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.email) + " ")])]), _c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "200px",
      "size": "small"
    }
  }, [!_vm.payload.is_in_paying_team ? _c('el-form-item', {
    attrs: {
      "label": "Paying Status"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.updatePayingStatus
    }
  }, [_vm._v("Update Paying Status")])], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "created_at", $$v);
      },
      expression: "payload.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "name", $$v);
      },
      expression: "payload.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.email,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "email", $$v);
      },
      expression: "payload.email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Credit card last digits"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.credit_card_last_digits,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "credit_card_last_digits", $$v);
      },
      expression: "payload.credit_card_last_digits"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Default team slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.default_team_slug,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "default_team_slug", $$v);
      },
      expression: "payload.default_team_slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Archived"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_archived,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_archived", $$v);
      },
      expression: "payload.is_archived"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.payload.role,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "role", $$v);
      },
      expression: "payload.role"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "admin",
      "label": "admin"
    }
  }), _c('el-option', {
    attrs: {
      "value": "user",
      "label": "user"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Intent"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.intent,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "intent", $$v);
      },
      expression: "payload.intent"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Workplace type"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.workplace_type,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "workplace_type", $$v);
      },
      expression: "payload.workplace_type"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Signup landing page url"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.signup_landing_page_url,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "signup_landing_page_url", $$v);
      },
      expression: "payload.signup_landing_page_url"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Signup source"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.signup_source,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "signup_source", $$v);
      },
      expression: "payload.signup_source"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Referrer"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.referrer,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "referrer", $$v);
      },
      expression: "payload.referrer"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Update at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "updated_at", $$v);
      },
      expression: "payload.updated_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Latest paired design tool"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.latest_paired_design_tool,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "latest_paired_design_tool", $$v);
      },
      expression: "payload.latest_paired_design_tool"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "clearable": ""
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.generateRandomPassword
    }
  }, [_vm._v("Generate password")]), _vm.password ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("Set password")]) : _vm._e()], 1), _c('el-form-item', {
    attrs: {
      "label": "Impersonate"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.impersonate
    }
  }, [_vm._v("Impersonate")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Unlock projects"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.unlockProjects
    }
  }, [_vm._v("Unlock projects")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Experiments"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.experiments,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "experiments", $$v);
      },
      expression: "payload.experiments"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Beta Features"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.beta_features,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "beta_features", $$v);
      },
      expression: "payload.beta_features"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "VIP"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.upgradeToProVIP
    }
  }, [_vm._v("Upgrade")]), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.downgradeFromProVIP
    }
  }, [_vm._v(" Downgrade ")])], 1), _c('el-form-item', {
    attrs: {
      "label": "User devices"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.deleteUserDevices
    }
  }, [_vm._v(" Delete devices ")])], 1), _c('el-form-item', {
    attrs: {
      "label": "User onboarding"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.deleteUserOnboarding
    }
  }, [_vm._v(" Reset onboarding ")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Revoke Figma OAuth"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.revokeFigmaOAuth
    }
  }, [_vm._v("Revoke")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Generate API Key"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.generateAPIKey
    }
  }, [_vm._v("Generate")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Use webcontainer"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.use_webcontainer,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "use_webcontainer", $$v);
      },
      expression: "payload.use_webcontainer"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Abuse"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reportAbuse
    }
  }, [_vm._v(" Mark as abuse ")]), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.purgePlaygrounds
    }
  }, [_vm._v(" Delete all playgrounds ")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }